import { useRoutes } from 'react-router-dom';

import MainRoutes from './MainRoutes';
import NotFoundRoute from './NotFoundRoute';

export default function ThemeRoutes() {
    return useRoutes([MainRoutes, NotFoundRoute]);
}